import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SelectSingleSF from '../../../widgets/input/SelectSingleSF'
import TokensNavUI from '../../../components/superUser/loan/util/TokensNavUI'
import LoanProperty2ListSF from '../../../components/superUser/loan/util/LoanProperty2ListSF'
import DirectorListSF from '../../../components/superUser/loan/DirectorListSF'
import './TokenListPage.css'

const GeneralTokenListPageUI = ({
  context,
  errorList,
  loan,
  directorList,
  propertyList,
  selectedDocType,
  docTypeOptionList,
  onDocTypeChange,
  onRefreshClick,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_tl'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !directorList || !propertyList} loan={loan} page='tokenS'
    dimension='w768'
  >
    {
      (!loan || !errorList || !directorList || !propertyList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && directorList && propertyList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Tokens</b></span>
            </span>
          }
          right={
            <span className='g_select_container'>
              <SelectSingleSF
                optionList={docTypeOptionList}
                selectedKey={selectedDocType || 'all'}
                onChange={onDocTypeChange}
                placeholder='Document type'
              />
            </span>
          }
        />

        <TokensNavUI context={context} loan={loan} page='tokenG' />

        <LoanProperty2ListSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          category='general_uw' categoryLabel='General tokens for underwriter' propertyList={propertyList}
        />

        <DirectorListSF context={context} loan={loan} directorList={directorList} onRefreshClick={onRefreshClick} />

        <LoanProperty2ListSF context={context} loan={loan} onRefreshClick={onRefreshClick}
          category='general_l' categoryLabel='General tokens for legal' propertyList={propertyList}
        />

      </div>
    }
  </SuperUserLoanPageUI>

export default GeneralTokenListPageUI
